import React, { Component } from "react";
import WmsCollapse from "../../components/WmsCollapse/WmsCollapse.jsx";
import WmsInput from "../../components/WmsInput/WmsInput.jsx";

export class PurolatorAccountInfoComponent extends Component {

    constructor(props) {
        super(props);
        
        this.translate = window.translate;
        this.$rootScope = window;
        this.state = { }
    }


    render() {
        return (
            <WmsCollapse
                id={"carrierAccountInformation"}
                headerLabel={this.translate("Label_Account_Information")}
                showCollapseText={false}
                showCollapseIcon={false}
            >
                <div className="account-info-section">
                    <div className="display-inline">
                    <WmsInput
                        id="nickname"
                        inputName="Nickname"
                        wmsSelector={this.props.selector + "nickname"}
                        onChangeFunc={this.props.handleConnectionObjChange}
                        label={this.translate('Label_Account_Nick_Name')}
                        required={true}
                        value={this.props.connectionObj.Nickname}
                        extraWrapperClass={"width-40"}
                    />
                    <WmsInput
                        id="apiKey"
                        inputName="ApiKey"
                        wmsSelector={this.props.selector + "apiKey"}
                        onChangeFunc={this.props.handleConnectionObjChange}
                        label={this.translate("Label_Purolator_Account_Number")}
                        required={true}
                        value={this.props.connectionObj.ApiKey}
                        extraWrapperClass={"width-40"}
                    />
                    </div>
                    <WmsInput
                        id="passphrase"
                        inputName="Passphrase"
                        wmsSelector={this.props.selector + "passphrase"}
                        onChangeFunc={this.props.handleConnectionObjChange}
                        label={this.translate("Label_Activation_key")}
                        required={true}
                        value={this.props.connectionObj.Passphrase}
                        extraWrapperClass={"width-100"}
                    />
                </div>
            </WmsCollapse>
        );
    }
}
